import { TableDefinitionEditorStore } from '@/tableDefinitionEditor/tableDefinitionEditor.store';

/**
 * Store for the scaling table definition editor
 * Table definition state is not stored in worksteps, so we separate the logic of what table is being looked at
 * here, which is stored in the workstep, while the table definition state is stored in the table definition store
 * which is updated when we receive messages from the server on the socket for table definitions.
 * The corresponding actions file will be the templated tableDefinitionEditor.actions file.
 * The base TableDefinitionEditorStore class contains all handler functions, getters and state management
 */
export class ScalingTableEditorStore extends TableDefinitionEditorStore {
  static readonly storeName = 'sqScalingTableEditorStore';
  override handlers = {
    SCALING_SET_TABLE_ID: this.setTableId,
    SCALING_RESET_TABLE_EDITOR_STORE: this.reset,
    SCALING_SET_SHOW_CONFIGURE_SEARCH: this.setShowConfigureSearch,
    SCALING_SET_COLUMN_TO_EDIT: this.setColumnToEdit,
    SCALING_SET_SHOW_COLUMN_PROPERTIES: this.setShowColumnProperties,
    SCALING_SET_ENABLE_TREE_CREATION: this.setEnableTreeCreation,
    SCALING_SET_SELECTED_COLUMN_OPTION: this.setSelectedColumnOption,
    SCALING_SET_SHOW_SIDE_PANE: this.setShowSidePane,
    SCALING_SET_SHORTCUT_SOURCE_COLUMN: this.setShortcutSourceColumn,
  };
}
